export interface IInitInvoice {
  HasKsef: boolean;
  Seller: IInvoiceSellerData;
  VatRates: IVatRate[];
}

export interface IInvoiceSellerData {
  Name: string;
  NIP: string;
  Address?: string;
  Email?: string;
}

export interface IVatRate {
  Id: number;
  Symbol: string;
  Name: string;
  Rate: number;
}

export enum InvoiceUnits {
  Piece = 0,
  Hour = 1,
  Kg = 2,
  Km = 3,
  Liter = 4,
  Meter = 5,
  SquareMeter = 6,
  CubicMeter = 7,
  Ton = 8,
  Service = 9,
}

export interface IInvoiceRow {
  Id: string;

  Description: string;

  Quantity: number;
  Unit: InvoiceUnits;

  Netto: number;
  TotalNetto: number;
  VatRate?: number;
  Vat: number;
  Total: number;
}

export interface IInvoiceBuyerData {
  Name: string;
  Nip: string;
  Address?: string;
  Email?: string;
}
